import React from "react";

import "./book-review-card.m.css";
import { Link } from "@quintype/components";
import { get } from "lodash";
import BookReviewButton from "../../atoms/BookReviewButton";
import BookPlaceHolderImage from "../../atoms/BookPlaceholderImage";

const BookReviewCard = ({ reviewInfo = {}, isSticky = false, isAMP = false }) => {
  const getCountAndPrice = () => {
    if (reviewInfo["page-count"] && reviewInfo.price) {
      return `${reviewInfo["page-count"]} Pages | ₹ ${reviewInfo.price}`;
    } else if (reviewInfo["page-count"]) {
      return `${reviewInfo["page-count"]} Pages`;
    } else if (reviewInfo.price) {
      return `₹ ${reviewInfo.price}`;
    } else return "";
  };

  const onClickUrl = get(reviewInfo, ["onclick-url"], "");

  const renderContent = () => (
    <>
      {reviewInfo["book-headline"] && <div styleName="title">{reviewInfo["book-headline"]}</div>}
      {reviewInfo.author && <div styleName="author">{reviewInfo.author}</div>}
      {!isSticky && reviewInfo.publication && <div styleName="publication">{reviewInfo.publication}</div>}
      {!isSticky && getCountAndPrice() && <div styleName="page-price">{getCountAndPrice()}</div>}
    </>
  );

  const renderAMPContent = () => (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    }}>
      {reviewInfo["book-headline"] && (
        <div style={{
          color: '#000',
          fontFamily: '"IBM Plex Serif"',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '120%',
          textTransform: 'capitalize',
          margin: 0
        }}>{reviewInfo["book-headline"]}</div>
      )}
      {reviewInfo.author && (
        <div style={{
          color: 'rgba(0, 0, 0, 0.60)',
          fontFamily: 'Literata',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '120%',
          textTransform: 'capitalize',
          margin: 0
        }}>{reviewInfo.author}</div>
      )}
      {!isSticky && reviewInfo.publication && (
        <div style={{
          color: '#000',
          fontFamily: 'Literata',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '120%',
          textTransform: 'capitalize',
          margin: 0
        }}>{reviewInfo.publication}</div>
      )}
      {!isSticky && getCountAndPrice() && (
        <div style={{
          color: '#000',
          fontFamily: 'Literata',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '120%',
          textTransform: 'capitalize',
          margin: 0
        }}>{getCountAndPrice()}</div>
      )}
    </div>
  );

  const renderImgContent = () => (
    <figure>
      {reviewInfo["book-cover-image"] ? (
        <img
          src={reviewInfo["book-cover-image"]}
          alt={`Cover of ${reviewInfo["book-headline"] || "book-review-cover-image"}`}
          width={400}
          style={{ aspectRatio: "3/4", objectFit: "cover" }}
        />
      ) : (
        <BookPlaceHolderImage />
      )}
    </figure>
  );

  const renderAMPImgContent = () => (
    <figure style={{ flexShrink: 0, margin: 0 }}>
      {reviewInfo["book-cover-image"] ? (
        <img
          src={reviewInfo["book-cover-image"]}
          alt={`Cover of ${reviewInfo["book-headline"] || "book-review-cover-image"}`}
          width={120}
          height={180}
          style={{
            width: '73px',
            height: '112px',
            borderRadius: '4px',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      ) : (
        <BookPlaceHolderImage />
      )}
    </figure>
  );

  // AMP rendering with proper styling
  if (isAMP) {
    return (
      <div style={{
        background: '#FFFFFF',
        borderRadius: '8px',
        border: '1px solid #E0E0E0',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        padding: '8px',
        maxWidth: '310px',
        margin: '8px auto'
      }}>
        <div style={{
          display: 'flex',
          gap: '16px',
          alignItems: 'center'
        }}>
          {onClickUrl ? <a href={onClickUrl} style={{ textDecoration: 'none', color: 'inherit' }}>{renderAMPImgContent()}</a> : renderAMPImgContent()}
          {onClickUrl ? <a href={onClickUrl} style={{ textDecoration: 'none', color: 'inherit' }}>{renderAMPContent()}</a> : renderAMPContent()}
        </div>
      </div>
    );
  }

  return (
    <div styleName={`wrapper ${isSticky ? "sticky-wrapper" : ""}`}>
      <div styleName="content">
        {isSticky && <BookReviewButton />}
        {onClickUrl ? <Link href={onClickUrl}>{renderImgContent()}</Link> : <div>{renderImgContent()}</div>}
        {onClickUrl ? <Link href={onClickUrl}>{renderContent()}</Link> : <div>{renderContent()}</div>}
      </div>
    </div>
  );
};

export default BookReviewCard;
